import React from 'react';
import {connect} from 'react-redux';

import './styles.scss';
import strings from 'utils/strings';

import {goToNextStep, setTestStepAnswers} from 'actions/index';

import {TEST_STEPS} from 'constants/index';

import Intro from './Intro';
import Test from './Test';
import Norming from './Norming';

const subSteps = [Intro, Test];
const subStepsNorming = [Intro, Norming];
class Leseproven extends React.Component {
	constructor(props) {
		super(props);
		this.handleNextSubstep = this.handleNextSubstep.bind(this);

		this.state = {
			isSubmitting: false,
			currentSubstepIndex: 0,
		};
	}

	handleNextSubstep(results, timeUsedInSeconds) {
		const {currentSubstepIndex} = this.state;
		const {candidateGrade} = this.props;

		const {onGoToNextStep, onSetTestStepAnswers} = this.props;

		const isLastStep = currentSubstepIndex === subSteps.length - 1;

		if (isLastStep) {
			const resultKeys = Object.keys(results);
			const formattedResults = resultKeys.map((id) => {
				const value = results[id];
				return {
					id,
					value,
				};
			});
			const resultsWithTime = [
				...formattedResults,
				{metaData: 'totalTimeTakenInSeconds', value: timeUsedInSeconds},
			];
			onSetTestStepAnswers(
				TEST_STEPS.LESEPRØVEN,
				resultsWithTime,
				candidateGrade
			)
				.then(() => {
					if (!this.state.isSubmitting) {
						this.setState({isSubmitting: true});
						onGoToNextStep();
					}
				})
				.catch(() => {
					this.setState({isSubmitting: false});
				});
		} else {
			this.setState({
				currentSubstepIndex: currentSubstepIndex + 1,
			});
			setTimeout(() => {
				window.scrollTo(0, 0);
			});
		}
	}

	render() {
		const {currentSubstepIndex} = this.state;

		const CurrentSubStep = this.props.isDldTest
			? subStepsNorming[currentSubstepIndex]
			: subSteps[currentSubstepIndex];

		return (
			<div className="lit-intro">
				{currentSubstepIndex === 0 && (
					<h1 className="lit-page-title">{strings.leseproven}</h1>
				)}
				<CurrentSubStep
					onNextStep={this.handleNextSubstep}
					isDldTest={this.props.isDldTest}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {candidateGrade} = state;
	return {
		candidateGrade,
	};
};

const mapDispatchToProps = {
	onGoToNextStep: goToNextStep,
	onSetTestStepAnswers: setTestStepAnswers,
};

export default connect(mapStateToProps, mapDispatchToProps)(Leseproven);
